/** @format */

import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import {
	selectAllProductSkusPartNumber,
	selectResolvedSkuPartNumber
} from '@pdp/data-access/state';

import { ATC_BUTTON_TEXTS } from '@pdp/add-to-cart/data-access';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { ProductAnalyticsService } from '@shared/data-access/analytics';
import { Store } from '@ngrx/store';
import { WINDOW } from '@shared/data-access/services';

@Component({
	selector: 'pdp-add-to-cart-see-available-stores-button',
	templateUrl: './see-available-stores-button.component.html',
	styleUrl: './see-available-stores-button.component.scss',
	imports: [HmfButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeeAvailableStoresButtonComponent {
	readonly store = inject(Store);
	protected readonly window = inject(WINDOW) as Window;
	private readonly productAnalyticsService = inject(ProductAnalyticsService);

	selectAllProductSkusPartNumber = this.store.selectSignal(selectAllProductSkusPartNumber);
	resolvedSkuPartNumber = this.store.selectSignal(selectResolvedSkuPartNumber);

	productSkusPartNumber = computed(() => {
		return this.selectAllProductSkusPartNumber() || [];
	});
	atcButtonTexts = ATC_BUTTON_TEXTS;

	openChangeStorePanel() {
		const storeSelectionValues = this.resolvedSkuPartNumber()
			? {
					skusArr: this.productSkusPartNumber(),
					selectedSkuVal: this.resolvedSkuPartNumber()
				}
			: { skusArr: this.productSkusPartNumber() };
		this.window.headerFunctions.storeSelection(storeSelectionValues);
		this.productAnalyticsService.triggerDataEmCall('PDP_seeAvailableStores_button');
	}
}
